import moment from 'moment-timezone';
import { NextRouter } from 'next/router';

export enum TabValue {
  details = 'Details',
  activity = 'Activity',
  rewards = 'My Rewards',
  referrals = 'Referrals',
}

export enum RedemptionType {
  discount = 'discount',
  cash = 'cash',
}

export enum LoyaltyExpirationMode {
  neverExpire = 0,
  expireFromLastTransaction = 1,
  expireFromDateGranted = 2,
  expireAllUnredeemed = 3,
}

export enum Mode {
  discount = 'PointsToDiscount',
  cash = 'CashBack',
}

export enum TierEarningBasis {
  points = 'points',
  dollars = 'dollars',
}

export enum TransactionType {
  redeemed = 'redeemed',
  newCustomerReward = 'New Customer Reward',
  manualAdjustment = 'Manual Adjustment',
  bulkUpdate = 'Bulk Update',
  migratedCarryover = 'Migrated Carryover',
  transactionReward = 'Transaction Reward',
  transactionSpend = 'Transaction Spend',
  returnedItem = 'Returned Item',
  voidedTransaction = 'Voided Transaction',
}

export type TabOption = {
  value: TabValue;
  label: string;
  sublabel?: string;
  data?: React.ReactNode;
  display?: boolean;
};

export type DPOSRewardsTabsProps = {
  children: React.ReactNode;
  onTabChange: (tab: string) => void;
  selectedTab: TabValue;
  tabOptions: TabOption[];
  showFeeBadgeInline?: boolean;
};

// DPOS datetime strings lack a timezone suffix — append Z so they're parsed as UTC, not local time.
export const toUtcString = (isoDate: string): string => (/Z|[+-]\d{2}:\d{2}$/.test(isoDate) ? isoDate : `${isoDate}Z`);

/** Formats an ISO date string as M/D/YY in the dispensary's local timezone. */
export const formatLoyaltyExpirationDate = (isoDate: string, timezone: string): string => {
  const m = moment.tz(toUtcString(isoDate), timezone);
  return `${m.month() + 1}/${m.date()}/${String(m.year()).slice(-2)}`;
};

/** Formats an ISO date string as MM/DD/YYYY at h:mm AM/PM in the dispensary's local timezone. */
export const formatTransactionDate = (dateString: string, timezone: string): string => {
  const m = moment.tz(toUtcString(dateString), timezone);
  return `${m.format('MM/DD/YYYY')} at ${m.format('h:mm A')}`;
};

export const isReferralsRoute = (router: NextRouter): boolean =>
  router.pathname.includes('/referral') || router.asPath.includes('/referral');

export const getDefaultTab = (redemptionType?: string | null, hasRewardsActivity?: boolean | null): TabValue => {
  if (redemptionType?.toLowerCase() === RedemptionType.discount) {
    return TabValue.rewards;
  }
  if (!hasRewardsActivity) {
    return TabValue.referrals;
  }
  return TabValue.activity;
};
